<template>
  <div>
    <bar-chart
      :chart-data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { reactiveProp } from 'vue-chartjs/es/mixins'

export default {
  name: 'VerticalBarChart',
  components: {
    barChart: {
      extends: Bar,
      mixins: [reactiveProp],
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        },
      },
    },
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
div {
  height: 400px;
}
</style>
